export default "__VITE_ASSET__0547f435__"